export const contextValue = 'https://schema.org/';

export const getSchemaTemplate = (type) => ({
  '@context': contextValue,
  '@type': type,
});
